export const tableWidth = "max-w-[1800px] w-full";
